import polycli from "../../../../assets/images/blogs/pp28/polycli.png";
import * as React from 'react';
export default {
  polycli,
  React
};